<div class="card">
  <div class="card-body d-flex flex-column justify-content-center">
    <ng-content select="[header]"></ng-content>
    <h5 class="mb-3"><strong> {{ label }} </strong></h5>

    <div #containerRef>
      <ngx-charts-bar-vertical-stacked
        #chart
        [id]="id"
        [view]="view"
        [scheme]="colorScheme"
        [barPadding]="50"
        [results]="data"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [showGridLines]="showGridLines"
        [rotateXAxisTicks]="false"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        [animations]="animations"
        [legendTitle]="legendTitle"
        [legendPosition]="legendPosition"
        [barPadding]="barPadding"
        [showDataLabel]="showDataLabel"
      >
        <ng-container *ngIf="customTooltip && customTooltipTpl">
          <ng-template #tooltipTemplate let-model="model">
            <ng-container
              [ngTemplateOutlet]="customTooltipTpl"
              [ngTemplateOutletContext]="{ model: model }"
            >
            </ng-container>
          </ng-template>
        </ng-container>
      </ngx-charts-bar-vertical-stacked>
    </div>
  </div>
</div>
